import * as React from 'react';
import { DataTableCell } from '@salesforce/design-system-react';
import { DataPreparationStatus } from 'lib/types';

interface ConditionalLinkProps {
	linkValue?: string;
	handleClick?: (item: {}) => void;
	item?: { status: DataPreparationStatus }; 
}
const ConditionalLink: React.SFC<ConditionalLinkProps> = ({ children, ...props}) => {
	const isLink = (props.item && props.item.status) === props.linkValue;
	const handleClick = (e: React.MouseEvent<{}>) => {
		if (props.handleClick) { props.handleClick(props.item || {}); }
	};
	const name = isLink ?
					<a href="javascript:void(0);" onClick={handleClick}>{children}</a> :
					children;

	return <DataTableCell {...props}>{name}</DataTableCell>;
};
ConditionalLink.displayName = DataTableCell.displayName;

export default ConditionalLink;


// WEBPACK FOOTER //
// ./src/lib/Overview/conditional-link.tsx